import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';
import { client } from '../../api/client';
import { getPosition } from '../../api/mobile';

const poisAdapter = createEntityAdapter({
    selectId: poi => poi.id_poi
});


const initialState = {
    featuredPois: poisAdapter.getInitialState({
        status: 'idle',
        error: null
    }),
    trendingPois: poisAdapter.getInitialState({
        status: 'idle',
        error: null
    }),
    foundPois: poisAdapter.getInitialState({
        status: 'idle',
        error: null
    }),
    preferredPois: poisAdapter.getInitialState({
        status: 'idle',
        error: null
    }),
    filters: {
        offset: 0
    },
    loadingMore: false,
    poiDetails: {
        status: 'idle',
        error: null,
        data: {
            id_poi: null
        }
    },
    favorite: {
        status: 'idle',
        error: null,
        poiIds: []
    },

};

export const fetchFeaturedPois = createAsyncThunk('pois/fetchFeaturedPois', async () => {
    const response = await client.get('/get_featured');
    
    return response;
});

export const fetchTrendingPois = createAsyncThunk('pois/fetchTrendingPois', async () => {
    const response = await client.get('/get_trending');
    
    return response;
});

export const fetchPreferredPois = createAsyncThunk('pois/fetchPreferredPois', async (userId) => {
    const response = await client.get(`/getFavoriteFull/${userId}`);

    return response;
});

export const searchPois = createAsyncThunk('pois/searchPois', async ({lat, lng,
        keyword = '', conv = false, sosta = false, serv = false, camp = false, attr = false, limit = 7,
        offset = 0, acc = false, pet = false, water = false, cp = false, el = false}) => {
    const postParams = {
        lat: lat,
        lon: lng,
        acc: acc ? 1 : 0,
        pet: pet ? 1 : 0,
        water: water ? 1 : 0,
        cp: cp ? 1 : 0,
        el: el ? 1 : 0
    };
    if (keyword) {
        postParams.txt = keyword.trim();
    }
    const response = await client.post(`/FL_get_places/${conv ? 1 : 0}/${sosta ? 1 : 0}/${serv ? 1 : 0}/${camp ? 1 : 0}/${attr ? 1 : 0}/${limit}/${offset}`,
            postParams);
    
    return response;
});

export const fetchPoi = createAsyncThunk('pois/fetchPoi', async (poiId) => {
    const position = await getPosition();
    const response = await client.post('/get_place/' + poiId, {lat: position.lat, lon: position.lng});
    return response;
});

export const markFavorite = createAsyncThunk('pois/markFavorite', async ({userId, poiId, add}) => {
    const response = await client.get(`/markFavorite/${userId}/${poiId}/${add ? 1 : 0}`);
    return response;
});

export const fetchFavorites = createAsyncThunk('pois/fetchFavorites', async (userId) => {
    const response = await client.get(`/getFavorite/${userId}`);
    return response;
});





const poisSlice = createSlice({
    name: 'pois',
    initialState,
    reducers: {
    },
    extraReducers: {
        [fetchFeaturedPois.pending]: (state, action) => {
            state.featuredPois.status = 'loading';
        },
        [fetchFeaturedPois.fulfilled]: (state, action) => {
            state.featuredPois.status = 'succeeded';
            
            poisAdapter.setAll(state.featuredPois, action.payload || []);
        },
        [fetchFeaturedPois.rejected]: (state, action) => {
            state.featuredPois.status = 'failed';
            state.featuredPois.error = action.payload;
        },
        [fetchTrendingPois.pending]: (state, action) => {
            state.trendingPois.status = 'loading';
        },
        [fetchTrendingPois.fulfilled]: (state, action) => {
            state.trendingPois.status = 'succeeded';

            poisAdapter.setAll(state.trendingPois, action.payload);
        },
        [fetchTrendingPois.rejected]: (state, action) => {
            state.trendingPois.status = 'failed';
            state.trendingPois.error = action.payload;
        },
        [searchPois.pending]: (state, action) => {
            if (!action.meta.arg.offset) {
                state.foundPois.status = 'loading';
            } else {
                state.loadingMore = true;
            }
        },
        [searchPois.fulfilled]: (state, action) => {
            state.foundPois.status = 'succeeded';
            let payload = {};
            if(action.payload) {
                payload = action.payload;
            }
            if (!action.meta.arg.offset) {
                poisAdapter.setAll(state.foundPois, payload);
            } else {
                poisAdapter.upsertMany(state.foundPois, payload);
                state.loadingMore = false;
            }

            state.filters = action.meta.arg;
        },
        [searchPois.rejected]: (state, action) => {
            state.foundPois.status = 'failed';
            state.foundPois.error = action.payload;
        },
        [fetchPoi.pending]: (state, action) => {
            state.poiDetails.status = 'loading';
        },
        [fetchPoi.fulfilled]: (state, action) => {
            state.poiDetails.status = 'succeeded';
            state.poiDetails.data = action.payload[0];
        },
        [fetchPoi.rejected]: (state, action) => {
            state.poiDetails.status = 'failed';
            state.poiDetails.error = action.payload;
        },
        [fetchPreferredPois.pending]: (state, action) => {
            state.preferredPois.status = 'loading';
        },
        [fetchPreferredPois.fulfilled]: (state, action) => {
            state.preferredPois.status = 'succeeded';
            if (action.payload !== null) {
                poisAdapter.setAll(state.preferredPois, action.payload);
            } else {
                poisAdapter.setAll(state.preferredPois, []);
            }
        },
        [fetchPreferredPois.rejected]: (state, action) => {
            state.preferredPois.status = 'failed';
            state.preferredPois.error = action.payload;
        },
        [markFavorite.pending]: (state, action) => {
            state.favorite.status = 'loading';
        },
        [markFavorite.fulfilled]: (state, action) => {
            state.favorite.status = 'succeeded';
            if (action.meta.arg.add) {
                state.favorite.poiIds.push(action.meta.arg.poiId);
            } else {
                state.favorite.poiIds = state.favorite.poiIds.filter(id => id != action.meta.arg.poiId);
            }
            state.preferredPois.status = 'idle';
        },
        [markFavorite.rejected]: (state, action) => {
            state.favorite.status = 'failed';
            state.favorite.error = action.payload;
        },
        [fetchFavorites.pending]: (state, action) => {
            state.favorite.status = 'loading';
        },
        [fetchFavorites.fulfilled]: (state, action) => {
            state.favorite.status = 'succeeded';
            state.favorite.poiIds = action.payload.map(favorite => favorite.fav_poi);
            state.preferredPois.status = 'idle';
        },
        [fetchFavorites.rejected]: (state, action) => {
            state.favorite.status = 'failed';
            state.favorite.error = action.payload;
        },
    }
});


export default poisSlice.reducer;

export const selectFilters = (state) => state.pois.filters;

export const selectPoiDetails = (state) => state.pois.poiDetails.data;

export const {
    selectAll: selectFoundPois,
    selectById: selectPoiById,
    selectIds: selectFoundPoiIds
} = poisAdapter.getSelectors(state => state.pois.foundPois);

export const {
    selectAll: selectFeaturedPois,
    selectById: selectFeaturedPoiById,
    selectIds: selectFeaturedPoiIds
} = poisAdapter.getSelectors(state => state.pois.featuredPois);

export const {
    selectAll: selectTrendingPois,
    selectById: selectTrendingPoiById,
    selectIds: selectTrendingPoiIds
} = poisAdapter.getSelectors(state => state.pois.trendingPois);

export const {
    selectAll: selectPreferredPois,
    selectById: selectPreferredPoiById,
    selectIds: selectPreferredPoiIds
} = poisAdapter.getSelectors(state => state.pois.preferredPois);

